import { API_URL } from "../config";

export async function authFetch(url, options = {}) {
  const accessToken  = localStorage.getItem("token");
  const refreshToken = localStorage.getItem("refreshToken");
  const isFormData   = options.body instanceof FormData;

  const makeHeaders = (token) => ({
    // Если мы не отправляем FormData и есть тело — ставим JSON
    ...(!isFormData && options.body != null
      ? { "Content-Type": "application/json" }
      : {}),
    ...(options.headers || {}),
    // Authorization только если токен есть
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  });

  // Первый запрос
  let response = await fetch(url, {
    ...options,
    headers: makeHeaders(accessToken),
  });

  // Если accessToken истёк — пробуем рефреш
  if (response.status === 403 && refreshToken) {
    const refreshRes = await fetch(`${API_URL}/auth/refresh`, {
      method:  "POST",
      headers: { "Content-Type": "application/json" },
      body:    JSON.stringify({ refreshToken }),
    });

    if (refreshRes.ok) {
      const { accessToken: newToken } = await refreshRes.json();
      localStorage.setItem("token", newToken);

      // Повторяем исходный запрос с новым токеном
      response = await fetch(url, {
        ...options,
        headers: makeHeaders(newToken),
      });
    } else {
      // Если рефреш не удался — чистим токены
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
    }
  }

  return response;
}
